// getBase64Image(bufferObj, fallbackImg)
// This function receives an object containing image buffer data and returns a base64-encoded image URL with the correct MIME type.
// It uses `detectImageType` to identify the image format, then encodes the buffer to base64 and builds a proper data URI.
// If the buffer is invalid or an error occurs, it returns a fallback image URL instead.
import { Buffer } from "buffer";
import detectImageType from "./detectImageType";

export default function getBase64Image(bufferObj, fallbackImg) {
    try {
      const buffer = Buffer.from(bufferObj?.data);
      const type = detectImageType(buffer);
      const base64 = buffer.toString("base64");
      return `data:${type};base64,${base64}`;
    } catch (error) {
      console.error("Error converting image buffer:", error);
      return fallbackImg;
    }
  }